export const DEFAULT_DOWN_BUTTON_OFFSET = 24;
export const DEFAULT_FILE_LIST_HEIGHT = 0;
export const DEFAULT_REPLY_MESSAGE_HEIGHT = 0;
export const OPENED_REPLY_MESSAGE_HEIGHT = 40;
export const DEFAULT_TEXT_INPUT_HEIGHT = 30;
export const MAX_TEXT_INPUT_HEIGHT = 116;
